import React, {useEffect, useState} from "react";
import { notifyMe } from "../../helper";
import { Skeleton, Space, Divider, Switch, Form, Radio  } from 'antd';


  const CommonSkeleton = ({pagetoshow}) => {
  const [email, setEmail] = useState('');


      if(pagetoshow == 'myaddress')
      {
          return (
            <>
            <div className="row addressskeleton">
              <div className="col-6 mt-100">

                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Space>
                    <Skeleton.Button className='addressskeletonbtn' active='true' size='default' shape='default' block='true' />
                    <Skeleton.Button className='addressskeletonbtn' active='true' size='default' shape='default' block='true' />
                  </Space>
              </div>
              <div className="col-6 mt-100">

                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 300 }} active='true' size='default' />
                  <br />
                  <br />
                  <Space>
                    <Skeleton.Button className='addressskeletonbtn' active='true' size='default' shape='default' block='true' />
                    <Skeleton.Button className='addressskeletonbtn' active='true' size='default' shape='default' block='true' />
                  </Space>
              </div>
            </div>


            </>
          )

      }
      else if(pagetoshow == 'myorders')
      {
        return (
          <>
          <div className="row orderskeleton">
            <div className="col-9 mt-100">
                <Skeleton.Input style={{ width: 650 }} className='orderskeletoninput' active='true' size='default' />
            </div>
            <div className="col-3 mt-100">
              <Skeleton.Button className='orderskeletonbtn' active='true' size='default' shape='default' block='true' />
            </div>
            <div className="col-9 mt-1">
                <Skeleton.Input style={{ width: 650 }} className='orderskeletoninput' active='true' size='default' />
            </div>
            <div className="col-3 mt-1">
              <Skeleton.Button className='orderskeletonbtn' active='true' size='default' shape='default' block='true' />
            </div>
            <div className="col-9 mt-1">
                <Skeleton.Input style={{ width: 650 }} className='orderskeletoninput' active='true' size='default' />
            </div>
            <div className="col-3 mt-1">
              <Skeleton.Button className='orderskeletonbtn' active='true' size='default' shape='default' block='true' />
            </div>
            </div>
          </>
        )
      }
      else if(pagetoshow == 'myordersdetails')
      {
        return (
          <>
          <div className="row orderskeleton">
            <div className="col-12 mt-100">
                <Skeleton.Input style={{ width: 800 }} className='orderskeletoninput' active='true' size='default' />
            </div>
            <div className="col-12 mt-1">
                <Skeleton.Input style={{ width: 800 }} className='orderskeletoninput' active='true' size='default' />
            </div>
            <div className="col-12 mt-1">
                <Skeleton.Input style={{ width: 800 }} className='orderskeletoninput' active='true' size='default' />
            </div>
            </div>
          </>
        )
      }
      else if(pagetoshow == 'myfavourites')
      {
        return (
          <>
          <div className="row favouriteskeleton">
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 150 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>

          </div>

          </>
        )
      }
      else if(pagetoshow == 'productlisting')
      {
        return (
          <>
          <div className="row favouriteskeleton">
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>
            <div className="col-2 mt-100">

                <Skeleton.Image />
                <br />
                <br />
                <Skeleton.Input style={{ width: 150 }} active='true' size='default' />
                <br />
                <br />
                <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                <br />
                <br />
            </div>

          </div>

          </>
        )
      }
      else if(pagetoshow == 'buyingprice')
      {
        return (
          <>

            <Skeleton.Input style={{ width: 70 }} active='true' size='default' />

          </>
        )
      }
      else if(pagetoshow == 'buyingtotalprice')
      {
        return (
          <>

          <Skeleton.Input style={{ width: 70 }} active='true' size='default' />
          <br />
          <br />
          <Skeleton.Input style={{ width: 70 }} active='true' size='default' />
          <br />
          <br />
          <Skeleton.Input style={{ width: 70 }} active='true' size='default' />
          </>
        )
      }
      else if(pagetoshow == 'productdetailcarosuel')
      {
        return (
          <>

            <div className="row favouriteskeleton">
              <div className="col-2 mt-100">

                  <Skeleton.Image />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                  <br />
                  <br />
              </div>
              <div className="col-2 mt-100">

                  <Skeleton.Image />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                  <br />
                  <br />
              </div>
              <div className="col-2 mt-100">

                  <Skeleton.Image />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                  <br />
                  <br />
              </div>
              <div className="col-2 mt-100">

                  <Skeleton.Image />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 100 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                  <br />
                  <br />
              </div>
              <div className="col-2 mt-100">

                  <Skeleton.Image />
                  <br />
                  <br />
                  <Skeleton.Input style={{ width: 150 }} active='true' size='default' />
                  <br />
                  <br />
                  <Skeleton.Button className='favouriteskeletonbtn' active='true' size='default' shape='default' block='true' />
                  <br />
                  <br />
              </div>

            </div>
          </>
        )
      }


}

export default CommonSkeleton;
